import { Card } from "@mui/material";
import Grid from "@mui/material/Grid2";
import { useFormikContext } from "formik";
import React from "react";

import MDBox from "@/components/atoms/MDBox";
import { MDButton } from "@/components/atoms/MDButton";
import MDTypography from "@/components/atoms/MDTypography";
import { SUBSCRIBE_PERMISSIONS } from "@/constants/modules.permissions";
import useAuth from "@/contexts/auth-context";
import { SubscribeFormMessages } from "@/messages/subscribe/subscribe-form.messages";

import PersonalDataForm from "./components/PersonalDataForm";
import { SubscribeFormData } from "../../types";

type Props = {
  messages: SubscribeFormMessages;
  isLoading: boolean;
};

function SubscribeFormCard({ messages, isLoading }: Props) {
  const { submitForm, values, isValid } = useFormikContext<SubscribeFormData>();
  const { checkPermissions } = useAuth();
  const hasNoPermissionToSubscribe = checkPermissions(SUBSCRIBE_PERMISSIONS.CREATE);

  const allFilled = () => {
    const requiredValues = { ...values };
    delete requiredValues.complement;
    return Object.values(requiredValues).every((v) => v !== "");
  };

  return (
    <Card sx={{ height: "100%" }}>
      <Grid container spacing={3}>
        <PersonalDataForm messages={messages} />
      </Grid>

      <MDBox>
        <Grid container spacing={3} alignItems="center">
          <Grid size={12}>
            <MDBox display="flex" justifyContent="center" gap={2}>
              <MDButton
                variant="gradient"
                color="dark"
                onClick={submitForm}
                isLoading={isLoading}
                disabled={!allFilled() || !isValid || hasNoPermissionToSubscribe}
              >
                {messages.subscribeButtonLabel}
              </MDButton>
            </MDBox>

            <Grid style={{ textAlign: "center" }} mt={1} size={12}>
              <MDTypography variant="body2" color="text" fontWeight={"regular"}>
                {messages.invoiceInfoMessage}
              </MDTypography>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default SubscribeFormCard;
